var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f36413b7-a5f8-4ddb-b567-d408ab636b57",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-6ea53f41-9b4b-410a-b5dd-e759d7d40b4a {\r\n        fill: #fff;\r\n      }\r\n\r\n      .uuid-fe886659-ece2-4c3d-87af-af2b0cc6fedd {\r\n        filter: url(#uuid-b11c1520-0be6-4d2a-88fc-13641de9d3fc);\r\n      }\r\n\r\n      .uuid-5549f44b-06e8-4de7-8f67-75491bd4bd4f {\r\n        fill: #79c90d;\r\n        filter: url(#uuid-c2469da2-0e8e-407e-9868-f34e16a7c034);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "uuid-c2469da2-0e8e-407e-9868-f34e16a7c034",
    "data-name": "drop-shadow-1",
    x: 38,
    y: -40,
    width: 1004,
    height: 1980,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "uuid-d2d05b5a-63e5-48ad-b550-1ec6fb2f4312",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "uuid-d2d05b5a-63e5-48ad-b550-1ec6fb2f4312",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "uuid-b11c1520-0be6-4d2a-88fc-13641de9d3fc",
    "data-name": "drop-shadow-2",
    x: 247,
    y: 759,
    width: 579,
    height: 545,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "uuid-41ebd0a0-2adb-4b1f-82df-f70ae4686aa2",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "uuid-41ebd0a0-2adb-4b1f-82df-f70ae4686aa2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-5549f44b-06e8-4de7-8f67-75491bd4bd4f",
    d: "M981.24,1021.33c0-152.04-76.9-286.1-193.93-365.45V0h-494.62v655.88c-117.02,79.35-193.93,213.41-193.93,365.45s76.9,286.1,193.93,365.45v454.53c0,17.89,23.21,24.9,33.11,10.01l214.2-322.11,214.2,322.11c9.91,14.9,33.11,7.89,33.11-10.01v-454.53c117.02-79.35,193.93-213.41,193.93-365.45Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "uuid-fe886659-ece2-4c3d-87af-af2b0cc6fedd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-6ea53f41-9b4b-410a-b5dd-e759d7d40b4a",
    d: "M440.47,1263.4h-.75c-7.62-.28-14.65-4.18-18.87-10.52l-139.09-209.75c-7.18-10.85-4.23-25.41,6.61-32.63,10.81-7.08,25.45-4.23,32.62,6.62l120.77,182.13,311.48-410.68c7.87-10.34,22.6-12.36,32.97-4.55,10.35,7.86,12.37,22.61,4.53,32.95l-331.52,437.1c-4.46,5.88-11.4,9.33-18.75,9.33Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/GreenCheck.5fd2f4100620ec48beb47ed33cf19dc2.svg";
export { ForwardRef as ReactComponent };